

import Vue, { ComponentOptions, VNode, VueConstructor } from 'vue';
import Component from 'vue-class-component';

@Component({
    template: `
    <div class="column-container stretch" >
        <h2>About Graphviewer</h2>
        <p>Graphviewer shows graphs and its clusters 
        in an animated fashion. The graphs are being layouted using
        <p style="margin: 1rem;">
            <a style="margin: 0.5rem;" target="_blank" href="https://graphviz.org/">Graphviz.Org</a>
        </p>
        tooling.
        </p>
        <p>A small node.js server called 
        <p style="margin: 1rem;">dotserver</p> will convert .dotfiles to svg on the fly
        and then render them using html/javascript in the graphviewer panel</p>
        <p>Finally the animation on the clusters is done by <i>Graphviewer</i>, using a version of TWEEN.js ported 
        direcly to typescript</p>
        <p>This demo application uses a full stack of things, incl. dependencies almost impossible to enumerate. The important ones are:
        <ul style="padding-left: 3rem;">
            <li>Typescript</li>
            <li>Vue</li>
            <li>Vue Class Component</li>
            <li>Vuetify</li>
            <li>Material Design Icons</li>
            <li>Sass</li>
        </ul>
        </p>
        <div class="grow"></div>
    </div>
`,
})
export class About extends Vue {


    created() {
    }

}

